<template>
  <div class="kChart">
    <!-- 标的弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="symbolVisible"
      width="560px"
      class="symbolDialog"
    >
    <div slot="title">
      <span class="dialog-title">更换因子</span>
      <span style="padding-left: 10px;">(可多选)</span>
    </div>
      <ul class="symbolDiaUl">
        <li>
          <!-- <p class="tit">选择行情:</p> -->
          <div class="head">
            <span class="wid5"></span>
            <span class="wid10">因子名称</span>
            <span class="wid10">因子类别</span>
            <span class="wid10">因子描述</span>
          </div>
          <div style="height: 296px;">
            <ul class="symbolDiaUl-list scroll-bar scroll-bar-gray">
                <el-checkbox-group v-model="getSelData" :max="10">
                  <el-checkbox :label="item"  v-for="(item,idx) in factorInfoTOList" :key="idx" class="factorList">
                     <li @click="selectBtn(item)">
                        <span class="wid10">{{item.factor_name}}</span>
                        <span class="wid10">{{item.factor_cate}}</span>
                        <span class="wid10 ellipsis" :title='item.factor_desc'>{{item.factor_desc}}</span>
                      </li>
                  </el-checkbox>
                </el-checkbox-group>
              <!-- <li
                v-for="(item,idx) in factorInfoTOList"
                :key="idx"
                :class="{'selectLi':item.symbol==subject.symbol&&item.exchange==subject.exchange}"
                @click="selectBtn(item)"
              >
                <span class="wid10"><el-checkbox v-model="radio" :label="idx"></el-checkbox></span>
                <span class="wid10">{{item.factor_name}}</span>
                <span class="wid10">{{item.factor_no}}</span>
                <span class="wid10">{{item.factor_cate}}</span>
                <span style="width:50px;">
                  <i class="el-icon-check I-check"  v-if="item.symbol==subject.symbol&&item.exchange==subject.exchange"></i>
                </span>
              </li> -->
            </ul>
          </div>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="save(false)" size="mini">取 消</el-button>
        <el-button type="primary" @click="save(true)" size="mini">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    headerData: {
      type: Object,
      required: true
    },
     // 已选择数据
    getKsubject:{
      type: Array,
      required: true
    },
    // 是否弹窗
     symbolVisible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      radio:this.getKsubject.factor_no,
      paramType: "0",
      loading: false,
      factorInfoTOList: [],
      typeInit: true,
      subject:this.getKsubject,
      getSelData: [],
    };
  },
  methods: {
    // 保存
    save(type){
      // console.log(this.radio)
        // this.symbolVisible = false;
        this.$emit('onSucceed',this.getSelData,type)
    },
    // 选择行情
    selectBtn(item){
        this.subject = item;
    },
    // 类型切换
    onchangeSel(item) {
      this.factorInfoTOList =
        item == "0"
          ? this.headerData.factorInfoTOList
          : this.headerData.factorInfoTOList.filter(res => res.type == item);
    },
    ngOnInit() {
      this.factorInfoTOList = this.headerData.factorInfoTOList;
      this.getKsubject.forEach((item,idx)=>{
        this.getSelData.push(item);
      })
      // this.radio=this.getKsubject;
    }
  },
  deactivated() {
    this.ngOnInit();
  },
  mounted() {},
  created() {}
};
</script>
<style lang="less" scoped>
// 弹窗
  .dialog-title{
    line-height: 24px;
    color: #57a3ef;
    font-size: 16px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
  }
.symbolDialog {
  /deep/ .el-dialog__body{
    padding: 20px 0;
  }
  /deep/ .el-checkbox-group{
        border-bottom: 1px solid #DDDDDD;
  }
 .el-checkbox-group /deep/ .el-checkbox__input{
       float: left;
    padding-top: 15px;
    padding-left: 10px;
  }
   .el-checkbox-group /deep/ .el-checkbox__label{
    padding-left: 10px;
    float: left;
    height: 42px;
    line-height: 42px;
    width: 490px;
  }
.el-checkbox-group /deep/ .el-checkbox{
    margin-right:0;
    width: 100%;
    height: 42px;
    line-height: 42px;
    border-top: 1px solid #DDDDDD;
  }
  .tit {
    color: #3f98f1;
    width: 64px;
    line-height: 30px;
    margin-right: 10px;
    line-height: 34px;
  }
  .symbolDiaUl-list {
    padding-top: 0px;
    text-align: center;
    // border-bottom: 1px solid rgba(221, 221, 221, 1);
    padding-bottom: 16px;
    // li:hover {
    //   background: #e9f4ff;
    //   color: #57a3ef;
    // }
    li {
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: #666666;
      cursor: pointer;
      > span {
        float: left;
      }
    }
  }
  .wid5 {
    width: 32px;
    height: 42px;
  }
  .wid10 {
    width: 160px;
  }
  .wid20 {
    width: 300px;
  }
  .head {
    text-align: center;
    color: #57A3EF;
    height: 42px;
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    line-height: 42px;
    > span {
      float: left;
    }
  }
  .symbolDiaUl {
    > li {
      clear: both;
      overflow: hidden;
      margin-bottom: 10px;
    }
    .I-check {
      font-size: 16px;
      color: #57a3ef;
      font-weight: 600;
    }
  }
  /deep/ .el-dialog__header {
    box-shadow: 0px 0px 4px 0px rgba(153, 153, 153, 1);
  }
  /deep/ .el-dialog__title {
    line-height: 24px;
    color: #57a3ef;
    font-size: 16px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
  }
  // /deep/ .el-dialog__body {
  //   padding: 20px 20px 0px 20px;
  // }
  .selectLi {
    background: #e9f4ff;
    color: #57a3ef;
  }
}
</style>
